import styled from '@emotion/styled';
import { Body } from '@components/templates/PageBody';
import { CrossIcon } from '@components/atoms/Icons/Cross';

export const PacsAetInfoWrap = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  margin: 40px 0;
  background-color: #fff;
  & div {
    display: flex;
    align-items: center;
  }
`;

export const PacsAetTitle = styled.div`
  width: 240px;
  height: 50px;
  padding: 0 16px 0 22px;
  border-left: 4px solid #7fe200;
  color: #fff;
  background-color: #00bf00;
  box-sizing: border-box;
`;

export const PacsAetValue = styled.div`
  width: calc((100% - 240px) / 2);
  height: 50px;
  padding: 0 16px 0 22px;
  color: #000;
  box-sizing: border-box;
`;

export const PacsServerSettingsBody = styled(Body)`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: 586px;
  max-height: calc(100vh - 464px);
  margin-top: 18px;
  border: 1px solid #e0e0e0;
  & > fieldset:nth-of-type(n) {
    & > div:nth-last-of-type(1) {
      visibility: visible;
    }
  }
  & fieldset {
    & table {
      & th {
        /* min-width: 236px; */
        word-break: break-word;
      }
      & td {
        & input {
          /* min-width: 236px; */
          padding: 0 12px;
        }
      }
    }
  }
`;

export const PacsServerSettingsFooter = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  border-width: 1px;
  border-top-width: 0;
  border-style: solid;
  border-color: #e0e0e0;
  box-sizing: border-box;
  background: #fafafa;
  cursor: pointer;
  &:before {
    content: '';
    ${CrossIcon};
  }
`;
